/**
 * Tính toán & kiểm tra tiền hoàn cho phiếu trả hàng.
 * Đẳng thức: tiền mặt + chuyển khoản + phí trả hàng = Tổng phải trả.
 * LƯU Ý: mọi tham số là SỐ đã unmask (gọi unMaskPrice ở nơi sử dụng).
 */

// Số tiền cần điền vào một ô khi bấm nút mũi tên "→".
// = phần còn thiếu để khớp đẳng thức, không âm.
export const getRefundRemaining = ({ total = 0, returnFee = 0, otherAmount = 0 }) => {
  const remaining = Number(total) - Number(returnFee) - Number(otherAmount);
  return remaining > 0 ? remaining : 0;
};

// Kiểm tra đẳng thức tiền hoàn.
// diff > 0 = vượt, diff < 0 = thiếu, diff === 0 = khớp.
export const validateRefundPayment = ({
  total = 0,
  returnFee = 0,
  cash = 0,
  transfer = 0,
}) => {
  const paid = Number(cash) + Number(transfer) + Number(returnFee);
  const diff = paid - Number(total);
  return { valid: diff === 0, diff };
};

// Đánh giá tiền hoàn theo quy tắc bất đối xứng: vượt → chặn, thiếu → chỉ cảnh báo.
// status: 'ok' (khớp) | 'over' (hoàn lố, diff > 0) | 'short' (hoàn thiếu, diff < 0).
// canSubmit: chỉ false khi hoàn lố (diff > 0).
export const evaluateRefund = ({
  total = 0,
  returnFee = 0,
  cash = 0,
  transfer = 0,
}) => {
  const { diff } = validateRefundPayment({ total, returnFee, cash, transfer });
  const status = diff > 0 ? 'over' : diff < 0 ? 'short' : 'ok';
  return { diff, status, canSubmit: diff <= 0 };
};
